import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const searchDropdownBuyItAgainSelector = createSelector(testTargetOffersSelector, offers => offers.searchDropdownBuyItAgain || Empty.Object);

export { searchDropdownBuyItAgainSelector };
